import * as firebase from 'firebase/app';

const config = {
  apiKey: 'AIzaSyD0zqnHFyytLRtQU2rIcVmGhyrc81PaYgM',
  authDomain: 'toothly-a3762.firebaseapp.com',
  databaseURL: 'https://toothly-a3762.firebaseio.com',
  projectId: 'toothly-a3762',
  storageBucket: 'toothly-a3762.appspot.com',
  messagingSenderId: '261366937921',
  appId: '1:261366937921:web:4a61d16f1247d87e',
};

const firebaseApp = firebase.initializeApp(config);
// firebase.firestore().enablePersistence();

export default firebaseApp;
